module.exports = __webpack_public_path__ + "fonts/NunitoSans-Regular.8c6ae4b.ttf";